import React, { useEffect } from "react";
import { useHistory, withRouter } from "react-router-dom";
import { useSelector } from "react-redux";

const NAV_MAP = {
  "Enhanced Insights": "enhancedPage",
  "Rep Performance": "repPage",
  "Other Insights": "othersPage",
  "Marketing Support Requests": "marketPage",
  "Growth Modeling": "growthModelingPage",
  "Pipeline Build & Sufficiency": "pipelineBuildandSuficencyPage",
  "Pipeline Velocity & Conversion": "pipelineVelocityandConversionPage",
  "Market Intel & Growth Levers": "marketIntelandGrowthLeversPage",
  "Sales Productivity": "salesProductivityPage",
  "Growth Science Insights": "growthScienceInsightsPage",
  "Custom Scorecards": "personalizedScorecardsPage",
  "Settings": "SettingsPage",
  "Product Performance": "productPage",
  "Product Insights": "productInsightsPage",
  "Customer Success": "customerSuccessPage",
  "Pipeline Progression": "pipelineProgressionPage",
};

const TimeSeriesComponent = (props) => {
  const history = useHistory();
  const user = useSelector((state) => state.app?.user);

  useEffect(() => {
    if (!user) return;
    const elements = user?.elements || [];
    const targetChartName = "Time Series projection of Closed Won";

    const groupObj = elements.find(
      (g) =>
        g.navItem !== "Favorites" &&
        g?.charts &&
        g.charts.some(
          (c) =>
            c?.Chart_Name?.trim().toLowerCase() ===
            targetChartName.trim().toLowerCase(),
        ),
    );
    const tsGroup = groupObj?.navItem;

    if (tsGroup && NAV_MAP[tsGroup]) {
      localStorage.setItem("skygeni-user-page", tsGroup);
      localStorage.setItem(
        `skygeni-user-${NAV_MAP[tsGroup]}`,
        targetChartName,
      );
      const targetKey = NAV_MAP[tsGroup];
      Object.values(NAV_MAP).forEach((key) => {
        if (key !== targetKey) {
          localStorage.removeItem(`skygeni-user-${key}`);
        }
      });

      if (props.match && props.match.params && props.match.params.filters) {
        localStorage.setItem("params", JSON.stringify(props.match.params.filters));
      }
      history.push("/");
      window.location.reload();
      return;
    } else {
      // Final Fallback if not found or group unknown
      localStorage.setItem("skygeni-user-page", "Growth Modeling");
      localStorage.setItem(
        "skygeni-user-growthModelingPage",
        targetChartName,
      );
      Object.values(NAV_MAP).forEach((key) => {
        if (key !== "growthModelingPage") {
          localStorage.removeItem(`skygeni-user-${key}`);
        }
      });
    }

    if (props.match && props.match.params && props.match.params.filters) {
      localStorage.setItem("params", JSON.stringify(props.match.params.filters));
    }
    history.push("/");
    window.location.reload();
  }, [user, history, props.match]);

  return <div style={{ margin: "1rem auto" }}>Loading...</div>;
};

const routerAddedTimeSeriesComponentComponent = withRouter(TimeSeriesComponent);
export default routerAddedTimeSeriesComponentComponent;
